import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { TimeSheetDetails } from "@/v2/api/time-sheet/FindOneTimeSheetLog";
import SaveTimeSheet from "@/v2/api/time-sheet/SaveTimeSheet";
import { useMutation } from "@tanstack/react-query";
import { format, parseISO } from "date-fns";
import { Loader2 } from "lucide-react";
import { MouseEvent, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function TimeSheetSaveBtn({
    timeSheetId,
    timeSheetDetails,
    getDeductionData,
}: {
    timeSheetId: string;
    timeSheetDetails: TimeSheetDetails;
    getDeductionData: () => {
        other_deductions: number;
        deduction_note: string;
    };
}) {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const month = useMemo(() => {
        return format(parseISO(timeSheetDetails.start_date), "yyyy-MM");
    }, [timeSheetDetails]);

    const { mutate, isPending } = useMutation({
        mutationFn: SaveTimeSheet,
        onSettled: () => {
            setOpen(false);
            navigate(`/time-sheet/approved?month=${month}`);
        },
    });

    function handleSubmit(e: MouseEvent<HTMLButtonElement>) {
        e.preventDefault();

        const latestDeductions = getDeductionData();

        const payload = {
            data: {
                title: timeSheetDetails.title,
                description: timeSheetDetails.description,
                status: "APPROVED" as const,
                note: timeSheetDetails.note,
                other_deductions:
                    latestDeductions.other_deductions ??
                    timeSheetDetails.other_deductions,
                deduction_note:
                    latestDeductions.deduction_note ??
                    timeSheetDetails.deduction_note,
            },
            timeSheetId: timeSheetId,
        };
        mutate(payload);
    }

    return (
        <AlertDialog open={open} onOpenChange={setOpen}>
            <AlertDialogTrigger asChild>
                <Button>Submit</Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>
                        Are you absolutely sure?
                    </AlertDialogTitle>
                    <AlertDialogDescription>
                        Warning: Submission is permanent. Please ensure all
                        hours are accurate before continuing
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel disabled={isPending}>
                        Cancel
                    </AlertDialogCancel>
                    <AlertDialogAction onClick={handleSubmit}>
                        {isPending ? (
                            <Loader2 className="h-4 w-4 animate-spin" />
                        ) : (
                            "Continue"
                        )}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
